var exports = {
  "k": "x804f0401--34e16a--container",
  "x": "x804f0401--34e16a--button",
};

module.exports = exports;
